import api from '../api';

const BASE_URL = '/api/v2/masterization';

const MasterAPI = {
	masterizeEpisode: ({ episodeId, payload }) =>
		api.patch(`${BASE_URL}/episode/${episodeId}`, payload),
};

export default MasterAPI;
